
<template>
    <div class="center">
        <details>
          <summary>
            DOCUMENTOS GENERALES
          </summary>
          
          <vs-button
            danger
            flat
            class="ml-auto"
            :disabled="!selected.length"
            @click="activeEliminar =! activeEliminar"
          >
            <i class="fas fa-trash-alt mr-2"></i>Eliminar documentos generales
          </vs-button>
          <div class="d-flex mt-4 mb-2">
            <vs-checkbox
              :indeterminate="selected.length == documentosGenerales.length" v-model="allCheck"
              @change="selected = $vs.checkAll(selected, documentosGenerales)"
            />
            <p class="ml-1 mb-0">{{allCheck == false ? 'Seleccionar todos los documentos generales' : 'Deseleccionar todos los documentos generales'}}</p>
          </div>
          <vs-row>
              <vs-col sm="12" lg="3"
                :key="i"
                v-for="(tr, i) in documentosGenerales"
                :data="tr"
                :is-selected="!!selected.includes(tr)"
              >
                <div class="documentoBox shadow-sm">
                  <div class="d-flex justify-content-between">
                    <h6 class="mb-0"><strong>{{tr.original_filename}}</strong></h6>
                    <vs-checkbox :val="tr" v-model="selected"/>
                  </div>
                  <hr>
                  <h6><small><strong>FECHA LÍMITE DE VISUALIZACIÓN</strong></small></h6>
                  <p>{{tr.fecha_visualizacion}}</p>
                  <h6><small><strong>DESCRIPCIÓN:</strong></small></h6>
                  <p>{{tr.descripcion ? tr.descripcion : 'Sin descripción'}}</p>
                  <div class="d-flex justify-content-between">
                    <vs-button
                      success
                      flat
                      @click="getDocumentosDownload(tr.id)"
                      
                    >
                      Descargar archivo
                    </vs-button>
                    
                    <vs-tooltip>
                      <md-menu md-size="small" md-align-trigger :md-offset-x="-30">
                          <vs-button
                            shadow
                            md-menu-trigger
                          >
                          <i class="fas fa-ellipsis-v"></i>
                          </vs-button>

                          <md-menu-content>
                              <md-menu-item @click="activeEditar =! activeEditar, selectRow = tr">Editar</md-menu-item>
                              <md-menu-item @click="activeEliminarIndividual =! activeEliminarIndividual, selectRow = tr">Eliminar</md-menu-item>
                          </md-menu-content>
                      </md-menu>
                      <template #tooltip>
                        Acciones
                      </template>
                    </vs-tooltip>
                  </div>
                </div>
              </vs-col>
          </vs-row>
        </details>
        <editar v-model="activeEditar" :selectRow="selectRow" @refreshTable="getRefresh"></editar>
        <eliminar v-model="activeEliminar" :docSelect="selected" @refreshTable="getRefresh"></eliminar>
        <eliminar-individual v-model="activeEliminarIndividual" :selectRow="selectRow" @refreshTable="getRefresh"></eliminar-individual>
    </div>
</template>
<script>
import editar from './modal/editar.vue'
import eliminarIndividual from './modal/eliminar-individual.vue'
import eliminar from './modal/eliminar.vue'
import evaluaciones from '../../../api/requests/docente/evaluaciones.js'
    export default {
      props:[
        'documentosGenerales',
      ],
      data:() => ({
        search: '',
        allCheck: false,
        selected: [],
        activeEditar: false,
        activeEliminarIndividual: false,
        activeEliminar: false,
        selectRow: []
      }),
      components:{
        editar,
        eliminar,
        eliminarIndividual
      },
      methods:{
        async getDocumentosDownload(id){
          try{
            const response = await evaluaciones.getDocumentosDownload(id)
          }catch(error){
            console.log(error)
          }
        },
        getRefresh(){
          this.emit('refreshTable')
        }
      }
    }
</script>

<style lang="scss" scoped>
.documentoBox{
    margin: 0.4rem;
    padding: 1rem;
    border-radius: 10px;
    border: 1px solid #dee2e6;
  }


details {
  padding: 0 1rem;
}
details + details {
  border-top: none;
}
details[open] {
    padding-bottom: 1em;
}  
summary {
  padding: 1rem 2em 1rem 0;
  font-size: 1.25rem;
  font-weight: bold;
  cursor: pointer;
}
</style>
